import React, { useState, useEffect } from 'react';
import { Box, Button, TextField, Typography, CircularProgress } from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";

export default function GarantForm({
  autocompleteOptions = [],
  searchValue = "",
  onSearchChange,
  loading = false,
  onAutocompleteChange,
  onFieldChange,
  fields,
  isExisting = false,
}) {
  const [showAdd, setShowAdd] = useState(false);

  useEffect(() => {
    if (isExisting) setShowAdd(false);
  }, [isExisting]);

  return (
    <>
      {!showAdd && (
        <>
            <Autocomplete
                freeSolo
                options={autocompleteOptions}
                getOptionLabel={opt =>
                  opt.nom ? `${opt.prenom || ""} ${opt.nom}` : ""
                }
                loading={loading}
                renderInput={params =>
                <TextField {...params}
                    label="Rechercher un garant existant"
                    value={searchValue}
                    onChange={e => onSearchChange(e.target.value)}
                    InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                        <>
                        {loading ? <CircularProgress color="inherit" size={16} /> : null}
                        {params.InputProps.endAdornment}
                        </>
                    ),
                    }}
                    fullWidth
                    margin="dense"
                />
                }
                onChange={(_, value) => onAutocompleteChange(value)}
                isOptionEqualToValue={(a, b) => a && b && a.id === b.id}
            />
            <Button
                size="small"
                color="primary"
                sx={{ mt: 1 }}
                onClick={() => {
                setShowAdd(true);
                onAutocompleteChange(null);
                }}
            >
            Nouveau garant
          </Button>
        </>
      )}
      {showAdd && (
        <Box sx={{ mt: 2, p: 2, border: '1px dashed #bbb', borderRadius: 2 }}>
            <Typography variant="subtitle2" color="textSecondary" sx={{ mt: 2, mb: 1 }}>
                Créer un nouveau garant
            </Typography>
            <Box sx={{ display: 'flex', gap: 1 }}>
                <TextField
                label="Prénom"
                name="prenom"
                value={fields.prenom}
                onChange={onFieldChange}
                margin="dense"
                disabled={isExisting}
                fullWidth
                />
                <TextField
                label="Nom"
                name="nom"
                value={fields.nom}
                onChange={onFieldChange}
                margin="dense"
                disabled={isExisting}
                fullWidth
                />
            </Box>
            <TextField
                label="Email"
                name="email"
                value={fields.email}
                onChange={onFieldChange}
                margin="dense"
                disabled={isExisting}
                fullWidth
            />
            <TextField
                label="Téléphone"
                name="telephone"
                value={fields.telephone}
                onChange={onFieldChange}
                margin="dense"
                disabled={isExisting}
                fullWidth
            />
            <TextField
                label="Adresse"
                name="adresse"
                value={fields.adresse}
                onChange={onFieldChange}
                margin="dense"
                fullWidth
            />
            <Box sx={{ display: 'flex', gap: 1 }}>
                <TextField
                label="Code Postal"
                name="code_postal"
                value={fields.code_postal}
                onChange={onFieldChange}
                margin="dense"
                fullWidth
                />
                <TextField
                label="Ville"
                name="ville"
                value={fields.ville}
                onChange={onFieldChange}
                margin="dense"
                fullWidth
                />
            </Box>
            <Button
                size="small"
                color="secondary"
                sx={{ mt: 1 }}
                onClick={() => setShowAdd(false)}
            >
                Annuler
            </Button>
        </Box>
      )}
    </>
  );
}
